import ConversationList from './conversations/conversation-list'
import ChatSearchBar from './ui/chat-search-bar'

const AllConversationsSidebar = () => {
  return (
    <div className="flex min-w-[400px] max-w-[400px] flex-col gap-3 overflow-y-auto pt-12">
      <div className="flex flex-col items-start justify-start gap-7 px-5">
        <h1 className="text-[26px] font-semibold leading-[135%] text-primary">Messages</h1>
        <ChatSearchBar />
      </div>
      <div className="flex-1 overflow-y-auto scrollbar-hide">
        <ConversationList />
      </div>
    </div>
  )
}

export default AllConversationsSidebar
